import React from 'react';
import { Navigate } from 'react-router-dom';
import { authApi } from '../services/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  if (!authApi.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && !authApi.hasRole(requiredRole)) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          <h4>Access Denied</h4>
          <p>You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;